module.exports = __webpack_public_path__ + "img/Kadeem.de33c498.jpg";